import { FieldTypes } from '@sitecore-jss/sitecore-jss-react-forms';
import React, { FC } from 'react';
import { TFieldWrapperProps } from '../../types/fieldWrapper.types';
import customFieldTypes from '../../types/field.types';
import PageTitle from '../pageTitleField';
import PageUrl from '../pageUrlField';

const FieldWrapper: FC<TFieldWrapperProps> = (props) => {
  const fieldWidthClassName = props?.field?.model?.cssClass || 'width-1';

  const fieldClassName = {
    [customFieldTypes.gdprConsentFieldTypeItemId]: ' sitecore-jss-form__field-wrapper--gdpr',
    [customFieldTypes.recaptchaFieldTypeItemId]: ' sitecore-jss-form__field-wrapper--recaptcha',
    [customFieldTypes.preferredCommunicationFieldTypeItemId]: ' sitecore-jss-form__field-wrapper--radio-btn',
    [FieldTypes.RadioButtonList]: ' sitecore-jss-form__field-wrapper--radio-btn',
  };

  const pageTitleComponent = [customFieldTypes.pageTitleFieldTypeItemId, PageTitle];
  const pageUrlComponent = [customFieldTypes.pageUrlFieldTypeItemId, PageUrl];
  const hasPageTitleOrPageUrl = [...pageTitleComponent, ...pageUrlComponent]?.includes(props?.field?.model?.fieldTypeItemId as FieldTypes);

  const fieldWrapperClassName = `sitecore-jss-form__field-wrapper ${fieldWidthClassName} ${hasPageTitleOrPageUrl ? 'hidden' : ''} ${
    fieldClassName[props.field.model.fieldTypeItemId] ?? ''
  }`;

  return <div className={fieldWrapperClassName}>{props.children}</div>;
};

export default FieldWrapper;
